import { ICypressProps } from 'interfaces/ICypressProps';
import { ReactElement } from 'react';
import styled from 'styled-components';

export interface IExternalLinkProps extends ICypressProps {
    url: string;
    children: ReactElement | string;
    className?: string;
}

const Link = styled.a`
    color: var(--text-link);
    text-decoration: none;

    &:hover {
        color: var(--text-link-hover);
        text-decoration: underline;
    }
`;

export function ExternalLink(props: IExternalLinkProps) {
    const { url, children, className, 'data-cy': cypressSelector } = props;

    return (
        <Link
            data-cy={cypressSelector}
            className={['external-link', className].join(' ')}
            target="_blank"
            rel="noopener noreferrer"
            href={url}
        >
            {children}
        </Link>
    );
}
